import { useState, useMemo } from 'react';
import uuid from 'uuid';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import _first from 'lodash/first';
import _get from 'lodash/get';
import { flattenObject } from '../../utils/objects';

const generateId = () => uuid().substring(0, 8);

const mockList = [
  {
    id: '62e92801',
    firstname: 'Damon',
    lastname: 'Decker',
    birthdate: '1999-08-20',
    address: 'Eveniet et dolores ',
    city: 'Et city',
    zip: '36149',
    country: 'ph',
    phone: '9121231234',
    email: 'damondecker@example.com',
  },
  {
    id: 'e9f5415c',
    firstname: 'Tanek',
    lastname: 'Adkins',
    birthdate: '2000-10-13',
    address: 'Reiciendis',
    city: 'Perspiciatis city',
    zip: '35691',
    country: 'ph',
    phone: '9971234567',
    email: 'tanek.adkins@gmail.com',
  },
  {
    id: '3ff6563a',
    firstname: 'Samuel',
    lastname: 'Byers',
    birthdate: '1999-06-09',
    address: 'Assumenda odio tempo',
    city: 'Consequatur',
    zip: '21784',
    country: 'ph',
    phone: '9551987654',
    email: 'samuelb@gmail.com',
  },
]

const useCustomer = () => {
  const [list, setList] = useState(mockList);
  const [loading, setLoading] = useState();

  const saveCustomer = item => {
    setLoading(true);
    return new Promise(resolve => {
      const flattenItem = flattenObject(item);
      const id = _get(flattenItem, 'id');
      let localList = list;
      if (id) {
        // remove customer here to be able to save updated details
        localList = _filter(list, i => i.id !== id);
      }
      const newItem = { ...flattenItem, id: id || generateId() };
      localList.push(newItem);
      setTimeout(() => setList(localList), 250);
      setLoading(false);
      resolve(item);
    })
  }

  const getCustomerDetails = id => {
    return new Promise(resolve => {
      const item = _filter(list, { id });
      resolve(_first(item));
    })
  }

  const deleteCustomer = id => {
    return new Promise(resolve => {
      const newList = _filter(list, i => i.id !== id);
      setList(newList);
      resolve();
    })
  }

  const resourceAsOption = useMemo(() => {
    return _filter(_map(list, ({ id, resource, quantity }) => ({
      label: `${resource} (${quantity})`,
      value: id,
      quantity,
    })), item => item.quantity > 0)
  }, [list])

  return { loading, list, saveCustomer, getCustomerDetails, deleteCustomer, resourceAsOption }
}

export default useCustomer;
